import { KeyboardAvoidingViewProps } from "react-native"

export const KeyboardAvoid = (props: KeyboardAvoidingViewProps) => props.children